module.exports = __webpack_public_path__ + "static/media/tartufo.ebb96637.jpg";